<div class="flex flex-column gap pt-2">
    <app-select-input
        [form]="form" id="address"
        [infiniteScroll]="store.addressScroll()"
        valueKey="id"
        label="person.address.label"
    >
        <ng-template #item let-item>
            {{ item | formatAddress }}
        </ng-template>
        <ng-template #selectedItem let-item>
            {{ item | formatAddress }}
        </ng-template>
    </app-select-input>
</div>
